import React from 'react';

const ManufacturerLogo = ({ manufacturer, size = 20, sx = {} }) => {
  if (!manufacturer) return null;
  return (
    <img 
      src={`/images/manufacturers/${manufacturer}.webp`} 
      alt={manufacturer} 
      style={{ width: size, height: 'auto', marginRight: 8, verticalAlign: 'middle', ...sx }} 
    />
  );
};

export default ManufacturerLogo;
